import RollinsLogo from "../../images/logo-rollins-college.svg";

const footerHoltUnderGrad = {
  logo: {
    alt: "Rollins College",
    image: RollinsLogo,
  },
  contactInfo: {
    title: "Office of Admission",
    street: "1000 Holt Ave - 2725",
    city: "Winter Park",
    state: "FL",
    zip: "32789",
    phone: "(407) 646-2037",
    email: "holtadmission@rollins.edu",
  },
  socialLinks: [
    {
      type: "Facebook",
      url: "https://www.facebook.com/rollinsgraduatestudies",
    },
    {
      type: "Instagram",
      url: "https://www.instagram.com/rollinsgraduatestudies/",
    },
    {
      type: "LinkedIn",
      url: "https://www.linkedin.com/company/rollinsgraduatestudies/",
    },
  ],
  contactInfoLinks: [
    {
      label: "",
      items: [
        {
          label: "News",
          url: "https://www.rollins.edu/graduate/news",
        },
        {
          label: "About",
          url: "/graduate/about",
        },
      ],
    },
  ],
  mainLinks: [
    {
      label: "Applied Behavior Analysis & Clinical Science",
      url: "/applied-behavior-analysis-masters",
    },

    {
      label: "Clinical Mental Health Counseling",
      url: "/clinical-mental-health-counseling-masters",
    },
    {
      label: "Business Administration (MBA)",
      url: "https://www.crummer.rollins.edu/",
    },
    {
      label: "Human Resources",
      url: "/masters-in-human-resources",
    },
    {
      label: "Liberal Studies",
      url: "/master-of-liberal-studies",
    },
    {
      label: "Public Health",
      url: "/master-of-public-health",
    },
    {
      label: "Teaching",
      url: "/master-of-arts-in-teaching",
    },
    {
      label: "Strategic Communication",
      url: "/masters-in-strategic-communication",
    },
    {
      label: "Racial Reconciliation and Community Restoration Certificate",
      url: "/racial-reconciliation-and-community-restoration",
    },
  ],
  miscLinks: [
    {
      label: "Information About",
      items: [
        {
          label: "Full-Time Undergraduate",
          url: "/college-of-liberal-arts/",
        },
        {
          label: "Transferring to Rollins",
          url: "/transfer-to-rollins-college/",
        },
        {
          label: "Graduate Business & Executive Education",
          url: "https://www.crummer.rollins.edu/",
        },
        {
          label: "Professional Advancement",
          url: "/professional-advancement",
        },
        {
          label: "Graduate Studies",
          url: "/graduate",
        },
      ],
    },
  ],
  ctas: [],
  copyright: {
    year: "© 2022",
    website: {
      label: "Rollins College",
      url: "https://www.rollins.edu/",
    },
    links: [
      {
        label: "Privacy Policy",
        target: "_blank",
        url: "https://www.rollins.edu/the-fine-print/privacy-policy",
      },
    ],
  },
};

export default footerHoltUnderGrad;
